import { Button, Checkbox, Flex, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import nes_logo from '../resources/logo_nes.png'

export default function Login() {
  const navigate = useNavigate();
  const onFinish = async (values) => {
    try {
      const formData = new URLSearchParams();
      formData.append("username", values.username);
      formData.append("password", values.password);

      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/admin/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error("Invalid login");
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      
      // Getting user info
      const token = localStorage.getItem("token");
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/admin/me", {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      const user = await res.json();
      localStorage.setItem("user", user.username);
      navigate("/admin");
      message.success("Login successful!");
    } catch (error) {
      message.error("Login failed.");
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error("Login failed.");
  };

  return (
    <Flex gap={30} vertical justify='center' align='center' style={{ marginTop: 300 }}>
      <img src={nes_logo} alt="NES"/>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked" label={null}>
          <Checkbox>Remember me</Checkbox>
        </Form.Item>

        <Form.Item label={null}>
          <Button type="primary" htmlType="submit">
            Log in
          </Button>
        </Form.Item>
      </Form>
    </Flex>
  );
}